import { Collapse, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import {
  getWorkspaceSettlement
} from "../../../store/actions/reports/vatSettlement";
import { useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import MonthSlickSlider from "./monthSlickSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VatDetailReportPage from "./detail";
import VatMultiActivityReportPage from "./multiActivity";
import { isNumeric } from "../../../libs/utils";
// import BannerNotFound from "../../../assets/img/banner-notfound.png";
const Panel = Collapse.Panel;
const Option = Select.Option;

const VatReportPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const settlementsReport = useSelector(state => state.reports.vat);
  const settlementsList = settlementsReport?.settlements?.settlementApiResList;  

  const [isMultiactivity, setIsMultiactivity] = useState(false);
  const [currentSettlmentInfo, setCurrentSettlmentInfo] = useState(null);
  // const [singleBusinessId, setSingleBusinessId] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);  
  const [selectedYear, setSelectedYear] = useState(location?.state?.year);  

  const currentYear = new Date().getFullYear();
  const intl = useIntl();

  useEffect(() => {         
    const prevSelectedYear = localStorage.getItem("report_vat_year") || currentYear;
    const prevSelectedMonth = localStorage.getItem("report_vat_month") || new Date().getMonth();
    setSelectedYear(prevSelectedYear);    
    setSelectedMonth(prevSelectedMonth ? (isNumeric(prevSelectedMonth) ? parseInt(prevSelectedMonth) : prevSelectedMonth) : parseInt(prevSelectedYear) === currentYear ? new Date().getMonth() : 0);   
    dispatch(getWorkspaceSettlement(prevSelectedYear, "VAT_ADVANCE_MONTHLY"));
  }, [JSON.stringify(location)]);

  useEffect(() => {  
    if (!settlementsList || (isNumeric(selectedMonth) ? selectedMonth < 0 : !selectedMonth)) return; 
    const indexMonthSelected = settlementsList.findIndex(el => el.month === (isNumeric(selectedMonth) ? (selectedMonth + 1).toString() : selectedMonth));
    setIsMultiactivity(settlementsList[indexMonthSelected]?.businessSettlements.length>1);   

    /** Calcolo il consolida 
    let filteredWithData=[];
    if (settlementsList){
      filteredWithData = settlementsList.filter(current => current.businessSettlements.length > 0);        
    }
    const currentIndexInFilter = filteredWithData.findIndex(c => c.month === selectedMonth + 1);              
    */    
            
    const selectedMonthIndex = settlementsList.findIndex(el => el.month === selectedMonth);
    const enableConsolida = !!(!settlementsList[selectedMonthIndex]?.closed && ((selectedMonth === 0 || selectedMonth === "FIRST_QUARTER") || (selectedMonthIndex === settlementsList.length - 1 && !settlementsList[selectedMonthIndex]?.closed) || (settlementsList[selectedMonthIndex - 1]?.closed && !settlementsList[selectedMonthIndex + 1]?.closed)));    

    setCurrentSettlmentInfo({ state: { year: selectedYear, month: selectedMonth, enableConsolidate: enableConsolida, settlement: isNumeric(selectedMonth) ? settlementsList[parseInt(selectedMonth)] : settlementsList.find(el => el.month === selectedMonth) } });
  }, [selectedMonth, settlementsList]);
  
  const goToDetails = (businessId) => {    
    const indexMonthSelected = settlementsList.findIndex(el => el.month === (isNumeric(selectedMonth) ? (selectedMonth +1).toString() : selectedMonth));
    
    const currentBusiness = settlementsList[indexMonthSelected]?.businessSettlements.find(el => el.id === businessId);
    navigate(`/reports/vat-detail/${isNumeric(selectedMonth) ? selectedMonth+1 : selectedMonth}`, 
      { state: { 
        year: selectedYear, 
        month: selectedMonth,
        enableConsolidate: currentSettlmentInfo.state.enableConsolidate,
        settlement: {businessSettlements: currentBusiness ? [{...currentBusiness}] : []} } 
      });
  };
  
  const renderRange = (start, end) => {
    let items = [];
    if (start < end)
      for (let i = start; i <= end; i++) {
        items.push(<Option key={i} value={i}>
          {i}
        </Option>);
      }
    else
      for (let i = start; i >= end; i--) {
        items.push(<Option key={i} value={i}>
          {i}
        </Option>);
      }
    return items;
  };  
  return (
    <div className="vatHeader" data-testid="vat-settlement">     
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={({ isActive }) => <div className="title"><FontAwesomeIcon icon={["far", isActive? "chevron-up": "chevron-down"]}/></div>} 
        className="site-collapse-custom-collapse"
      >
        <Panel header={<div className="title">
          <FormattedMessage id="reports.vat.yearSelect"/>
        </div>} 
        key="1" className="site-collapse-custom-panel">
          <div style={{margin: "0 40px"}}>        
            <div><FormattedMessage id="reports.vat.yearRef"/></div>
            <Select
              style={{width: 239, paddingTop: 4}}
              showSearch
              placeholder={intl.formatMessage({id: "reports.vat.yearSelectPlaceholder"})}
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              value={selectedYear}
              filterOption={(input, option) => {
                return option.children.toString().indexOf(input) >= 0;
              }}
              onSelect={value => {                
                setSelectedYear(value);                          
                localStorage.setItem("report_vat_year", value);
                dispatch(getWorkspaceSettlement(value, "VAT_ADVANCE_MONTHLY")).then(() => {
                  setSelectedMonth(0); 
                });
                
              }}
            >
              {renderRange(currentYear, 2012)}
            </Select>
            <MonthSlickSlider currentSettlmentInfo={currentSettlmentInfo} businessId={isMultiactivity ? null : currentSettlmentInfo?.state?.settlement?.businessSettlements?.[0]?.id} setCurrentSettlmentInfo={setCurrentSettlmentInfo} selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} selectedYear={selectedYear} />
          </div>
        </Panel>
      </Collapse>
      
      {currentSettlmentInfo?.state && 
      ((!isMultiactivity) ?
        /* currentSettlmentInfo.state?.settlement?.businessSettlements.length === 0 ? (
          <div className="dbx-reports-result-notfound">
            <div><img src={BannerNotFound} alt="" /></div>
            <div><FormattedMessage id="reports.resultNotFound" /></div>
          </div>
        ):*/
        <VatDetailReportPage
          currentMonthSelected={(selectedMonth || selectedMonth === 0) ? (isNumeric(selectedMonth) ? (selectedMonth + 1) : selectedMonth) : localStorage.getItem("report_vat_month")}
          setSubtitleSection={() => { }}
          currentSettlmentInfo={currentSettlmentInfo}
          selectedYear={selectedYear}
          businessId={currentSettlmentInfo?.state?.settlement?.businessSettlements?.[0]?.id}
        /> : 
        <VatMultiActivityReportPage currentSettlmentInfo={currentSettlmentInfo} currentMonthSelected={(selectedMonth || selectedMonth === 0) ? (isNumeric(selectedMonth) ? (selectedMonth + 1) : selectedMonth) : localStorage.getItem("report_vat_month")} location={currentSettlmentInfo} currentSettlement={currentSettlmentInfo.state.settlement} goToDetails={goToDetails} businessId={null}/>)      
      }
     
    </div>
    
  );
};
export default VatReportPage;
